/** Physiotherapist CareHub — session catalog and caregiver rate helpers. */

import { PHYSIO_THERAPY_PROCEDURES } from "./nemaHourlyServiceList";

/**
 * Physiotherapy sessions offered on CareHub.
 * Prices / minimum durations from the NEMA_Care Physiotherapy Service List.
 */
export const PHYSIO_PROCEDURES = PHYSIO_THERAPY_PROCEDURES.map((p) => ({ ...p }));

export function createEmptyPhysioProcedureMap() {
  const map = {};
  for (const p of PHYSIO_PROCEDURES) {
    map[p.id] = {
      offered: true,
      priceInr: p.defaultPriceInr,
    };
  }
  return map;
}

export function mergePhysioProcedureMap(raw) {
  const base = createEmptyPhysioProcedureMap();
  if (!raw || typeof raw !== "object") return base;
  const next = { ...base };
  for (const p of PHYSIO_PROCEDURES) {
    const row = raw[p.id];
    if (!row || typeof row !== "object") continue;
    next[p.id] = {
      offered: row.offered !== false,
      priceInr:
        Number.isFinite(Number(row.priceInr)) && Number(row.priceInr) > 0
          ? Math.round(Number(row.priceInr))
          : p.defaultPriceInr,
    };
  }
  return next;
}
